import { SearchControlsMobile } from "@modules/SearchControls/SearchControlsMobile";
import SearchFooter from "@modules/SearchControls/SearchFooter";
import SearchPagination from "@modules/SearchControls/SearchPagination";
import React, { Component, createRef } from "react";
import Overridable from "react-overridable";
import { Container, Ref, Sticky } from "semantic-ui-react";
import {
  EmptyResults,
  ResultsLoader,
  Error,
  ResultsGrid,
} from "react-searchkit";

class LiteratureSearchMobile extends Component {
  stickyRef = createRef();

  render() {
    return (
      <Overridable
        id="LiteratureSearchMobile.layout"
        stickyRef={this.stickyRef}
      >
        <Container fluid className="grid-documents-search">
          <ResultsLoader>
            <EmptyResults />
            <Error />
            <Ref innerRef={this.stickyRef}>
              <Container fluid>
                <Overridable id="LiteratureSearchMobile.Controls">
                  <>
                    <Sticky context={this.stickyRef} offset={66}>
                      <SearchControlsMobile
                        ref={this.stickyRef}
                        modelName="LITERATURE"
                      />
                    </Sticky>
                    <Container textAlign="center">
                      <SearchPagination />
                    </Container>
                  </>
                </Overridable>

                <Overridable id="LiteratureSearchMobile.Body">
                  <Container className="fs-search-body" textAlign="center">
                    <ResultsGrid overridableId="mobile" />
                    <Overridable id="LiteratureSearchMobile.Footer">
                      <Container fluid className="search-results-footer">
                        <SearchFooter />
                      </Container>
                    </Overridable>
                  </Container>
                </Overridable>
              </Container>
            </Ref>
          </ResultsLoader>
        </Container>
      </Overridable>
    );
  }
}

export default Overridable.component(
  "LiteratureSearchMobile",
  LiteratureSearchMobile
);
